//functions
import apiComponents from "./apiComponents";
import getCookieParam from "./getCookieParam";

async function patchStepCount(step, currSubStep, nextSubStep, status) {
    if (getCookieParam('token') !== '') {
        if (window.location.pathname.includes('phone-number-verification') && getCookieParam('statusPercent') > 40) {
            document.cookie = 'subStep=' + nextSubStep + '; path=/';
            return 'updated';
        }
        else {
            return await fetch(apiComponents.customer, {
                headers: {
                    'Authorization': 'Bearer ' + getCookieParam('token'),
                    'content-type': 'application/json',
                    'accept': 'application/json'
                },
                method: "PATCH",
                body: JSON.stringify({
                    u_status: status,
                    u_step: step,
                    u_substep: currSubStep
                })
            }).then(async res => {
                document.cookie = 'subStep=' + nextSubStep + '; path=/';
                document.cookie = 'statusPercent=' + status + '; path=/';
                return 'updated';
            });
        }
    }
}

export default patchStepCount;